import { bus } from '../core/event-bus.js';
import { store } from '../core/state-store.js';
import { formatMs } from '../utils/format.js';
import { el } from '../utils/dom.js';

export function initNetworkMonitor() {
  const logContainer = document.getElementById('network-log');
  const clearBtn = document.getElementById('network-clear-btn');

  clearBtn.addEventListener('click', () => {
    logContainer.innerHTML = '';
  });

  bus.on('network:logged', (entry) => {
    _appendEntry(logContainer, entry);
  });

  bus.on('session:started', () => {
    logContainer.innerHTML = '';
  });
  bus.on('session:reset', () => {
    logContainer.innerHTML = '';
  });

  _observeNetworkRequests();
}

function _appendEntry(container, entry) {
  const row = el('div', {
    className: 'network-entry',
    'data-testid': 'network-entry',
  }, [
    el('span', { className: 'network-time', textContent: formatMs(entry.timestamp) }),
    el('span', { className: 'network-type', textContent: `[${entry.initiator}]` }),
    el('span', { className: 'network-url', textContent: entry.url, title: entry.url }),
  ]);

  container.insertBefore(row, container.firstChild);
}

/**
 * Uses PerformanceObserver to watch for tracking pixel requests and
 * other network activity initiated by rmp-vast (beacons, images, fetches).
 */
function _observeNetworkRequests() {
  if (typeof PerformanceObserver === 'undefined') return;

  try {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        const url = entry.name;
        if (!url) continue;

        // Filter to likely tracking/beacon URLs
        if (_isTrackingRequest(url)) {
          let initiator = 'tracking';
          if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
            initiator = 'fetch';
          } else if (entry.initiatorType === 'img') {
            initiator = 'pixel';
          } else if (entry.initiatorType === 'beacon') {
            initiator = 'beacon';
          }
          store.addNetworkEntry(url, initiator);
        }
      }
    });

    observer.observe({ type: 'resource', buffered: false });
  } catch {
    // PerformanceObserver not supported or resource timing not available
  }
}

function _isTrackingRequest(url) {
  const lowerUrl = url.toLowerCase();

  // Filter out our own app assets
  if (url.includes('/src/') || url.includes('/node_modules/') || url.includes('/@vite/')) {
    return false;
  }

  // Ignore browser/site icon requests (not ad tracking)
  if (
    lowerUrl.endsWith('/favicon.ico') ||
    lowerUrl.includes('/favicon.') ||
    lowerUrl.includes('apple-touch-icon') ||
    lowerUrl.includes('site.webmanifest')
  ) {
    return false;
  }

  // Include common tracking patterns
  const trackingPatterns = [
    'ping', 'track', 'beacon', 'impression', 'click',
    '.gif', '.png?', 'pixel', 'log', 'event',
    'vast', 'ad', 'creative',
  ];

  return trackingPatterns.some(p => lowerUrl.includes(p)) ||
    // Include any external domain requests during ad playback
    !url.startsWith(window.location.origin);
}
